import actions from './actions';

const {
  POST_CAR_IMPORT_BEGIN,
  POST_CAR_IMPORT_SUCCESS,
  POST_CAR_IMPORT_FAILED,
  LOGOUT_USER,
  POST_LOGIN_BEGIN,
  POST_LOGIN_FAILED,
  POST_LOGIN_SUCCESS,
  GET_CAR_AMIGOS_BEGIN,
  GET_CAR_AMIGOS_FAILED,
  GET_CAR_AMIGOS_SUCCESS,
  GET_CAR_AMIGOS_DETAIL_BEGIN,
  GET_CAR_AMIGOS_DETAIL_FAILED,
  GET_CAR_AMIGOS_DETAIL_SUCCESS,
  GET_IMPORTED_CARS_BEGIN,
  GET_IMPORTED_CARS_FAILED,
  GET_IMPORTED_CARS_SUCCESS,
  GET_IMPORTED_CAR_IDS_BEGIN,
  GET_IMPORTED_CAR_IDS_FAILED,
  GET_IMPORTED_CAR_IDS_SUCCESS,
  DELETE_IMPORTED_CAR_BEGIN,
  DELETE_IMPORTED_CAR_FAILED,
  DELETE_IMPORTED_CAR_SUCCESS,
  REQUEST_CAR_BEGIN,
  REQUEST_CAR_FAILED,
  REQUEST_CAR_SUCCESS,
  GET_REQUESTED_CAR_BEGIN,
  GET_REQUESTED_CAR_SUCCESS,
  GET_REQUESTED_CAR_FAILED,
  RE_REQUEST_CAR_BEGIN,
  RE_REQUEST_CAR_FAILED,
  RE_REQUEST_CAR_SUCCESS,
  PUT_CAR_INSPECTION_BEGIN,
  PUT_CAR_INSPECTION_FAILED,
  PUT_CAR_INSPECTION_SUCCESS,
  PUT_PURCHASE_ORDER_BEGIN,
  PUT_PURCHASE_ORDER_FAILED,
  PUT_PURCHASE_ORDER_SUCCESS,
  PUT_START_PAYMENT_BEGIN,
  PUT_START_PAYMENT_FAILED,
  PUT_START_PAYMENT_SUCCESS,
  IMPORTED_CAR_REORDER_BEGIN,
  IMPORTED_CAR_REORDER_FAILED,
  IMPORTED_CAR_REORDER_SUCCESS,
  SET_IMPORTED_CARS,
  SET_ALL_IMPORTED_CAR_IDS,
  RE_FETCH_IMPORTED_CAR_BEGIN,
  RE_FETCH_IMPORTED_CAR_SUCCESS,
  RE_FETCH_IMPORTED_CAR_FAILED
} = actions;

const initState = {
  carAmigoCars: [],
  alreadyImportedCars: [],
  carAmigoDetail: null,
  currentPage: 1,
  pageLimit: 10,
  authLoading: false,
  apiLoading: false,
  error: null,
  isLoggedIn: true,
  total: 0,
  importLoading: false,
  importedCars: [],
  importedCarsPage: 1,
  importedCarsLimit: 10,
  importedCarsTotal: 0,
  allImportedCarIds: [],
  allImportedCarIdsFetched: false,
  requestedCars: [],
  requestedCarsPage: 1,
  requestedCarsLimit: 10,
  requestedCarsTotal: 0,
  reRequestingId: null,
  deletingCarId: null,
  carInspectionId: null,
  carPurchaseId: null,
  carPaymentId: null,
  importedCarsReordering: false,
};

const CarAmigoImportReducer = (state = initState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case POST_LOGIN_BEGIN:
      return {
        ...state,
        authLoading: true,
      };
    case POST_LOGIN_SUCCESS:
      return {
        ...state,
        authLoading: false,
        isLoggedIn: true,
      };
    case POST_LOGIN_FAILED:
      return {
        ...state,
        authLoading: false,
        isLoggedIn: false,
        err,
      };
    case LOGOUT_USER:
      return {
        ...state,
        authLoading: false,
        isLoggedIn: false,
      };
    case GET_CAR_AMIGOS_BEGIN:
      return {
        ...state,
        apiLoading: true,
        carAmigoCars: [],
      };
    case GET_CAR_AMIGOS_SUCCESS:
      return {
        ...state,
        apiLoading: false,
        carAmigoCars: data.data,
        currentPage: data.page,
        pageLimit: data.pageLimit,
        total: data.total,
      };
    case GET_CAR_AMIGOS_FAILED:
      return {
        ...state,
        apiLoading: false,
        error: err,
        total: 0,
      };
    case GET_CAR_AMIGOS_DETAIL_BEGIN:
      return {
        ...state,
        apiLoading: true,
      };
    case GET_CAR_AMIGOS_DETAIL_SUCCESS:
      return {
        ...state,
        apiLoading: false,
        carAmigoDetail: data,
      };
    case GET_CAR_AMIGOS_DETAIL_FAILED:
      return {
        ...state,
        apiLoading: false,
        err,
      };
    case REQUEST_CAR_BEGIN:
      return {
        ...state,
      };
    case REQUEST_CAR_SUCCESS:
      return {
        ...state,
        data,
      };
    case REQUEST_CAR_FAILED:
      return {
        ...state,
        err,
      };
    case GET_REQUESTED_CAR_BEGIN:
      return {
        ...state,
        apiLoading: true,
      };
    case GET_REQUESTED_CAR_SUCCESS:
      return {
        ...state,
        apiLoading: false,
        requestedCars: data.data,
        requestedCarsPage: data.currentPage,
        requestedCarsLimit: data.pageLimit,
        requestedCarsTotal: data.total,
      };
    case GET_REQUESTED_CAR_FAILED:
      return {
        ...state,
        apiLoading: false,
        err,
      };
    case RE_REQUEST_CAR_BEGIN:
      return {
        ...state,
        reRequestingId: data,
      };
    case RE_REQUEST_CAR_SUCCESS:
      return {
        ...state,
        reRequestingId: null,
      };
    case RE_REQUEST_CAR_FAILED:
      return {
        ...state,
        reRequestingId: null,
      };
    case GET_IMPORTED_CARS_BEGIN:
      return {
        ...state,
        apiLoading: true,
        importedCars: [],
      };
    case GET_IMPORTED_CARS_SUCCESS:
      return {
        ...state,
        apiLoading: false,
        importedCars: data.cars,
        importedCarsTotal: data.total,
        importedCarsPage: data.currentPage,
        importedCarsLimit: data.pageLimit,
      };
    case GET_IMPORTED_CARS_FAILED:
      return {
        ...state,
        apiLoading: false,
        err,
      };
    case GET_IMPORTED_CAR_IDS_BEGIN:
      return {
        ...state,
        allImportedCarIds: [],
      };
    case GET_IMPORTED_CAR_IDS_SUCCESS:
      return {
        ...state,
        allImportedCarIds: data,
        allImportedCarIdsFetched: true
      };
    case GET_IMPORTED_CAR_IDS_FAILED:
      return {
        ...state,
        err,
      };
    case DELETE_IMPORTED_CAR_BEGIN:
      return {
        ...state,
        deletingCarId: data,
      };
    case DELETE_IMPORTED_CAR_SUCCESS:
      return {
        ...state,
        deletingCarId: null,
      };
    case DELETE_IMPORTED_CAR_FAILED:
      return {
        ...state,
        deletingCarId: null,
      };
    case POST_CAR_IMPORT_BEGIN:
      return {
        ...state,
        importLoading: true,
      };
    case POST_CAR_IMPORT_SUCCESS:
      return {
        ...state,
        importLoading: false,
      };
    case POST_CAR_IMPORT_FAILED:
      return {
        ...state,
        importLoading: false,
      };
    case PUT_CAR_INSPECTION_BEGIN:
      return {
        ...state,
        carInspectionId: data,
      };
    case PUT_CAR_INSPECTION_SUCCESS:
      return {
        ...state,
        carInspectionId: null,
      };
    case PUT_CAR_INSPECTION_FAILED:
      return {
        ...state,
        carInspectionId: null,
        err,
      };
    case PUT_PURCHASE_ORDER_BEGIN:
      return {
        ...state,
        carPurchaseId: data,
      };
    case PUT_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        carPurchaseId: null,
      };
    case PUT_PURCHASE_ORDER_FAILED:
      return {
        ...state,
        carPurchaseId: null,
        err,
      };
    case PUT_START_PAYMENT_BEGIN:
      return {
        ...state,
        carPaymentId: data,
      };
    case PUT_START_PAYMENT_SUCCESS:
      return {
        ...state,
        carPaymentId: null,
      };
    case PUT_START_PAYMENT_FAILED:
      return {
        ...state,
        carPaymentId: null,
      };
    case IMPORTED_CAR_REORDER_BEGIN:
      return {
        ...state,
        importedCarsReordering: true,
      };
    case IMPORTED_CAR_REORDER_SUCCESS:
      return {
        ...state,
        importedCarsReordering: false,
      };
    case IMPORTED_CAR_REORDER_FAILED:
      return {
        ...state,
        importedCarsReordering: false,
      };
    case SET_IMPORTED_CARS:
      return {
        ...state,
        importedCars: data,
      };
    case SET_ALL_IMPORTED_CAR_IDS:
      return {
        ...state,
        allImportedCarIds: data,
      };
    case RE_FETCH_IMPORTED_CAR_BEGIN:
      return {
        ...state,
        importLoading: true,
      };
    case RE_FETCH_IMPORTED_CAR_SUCCESS:
      return {
        ...state,
        importLoading: false,
      };
    case RE_FETCH_IMPORTED_CAR_FAILED:
      return {
        ...state,
        importLoading: false,
      };
    default:
      return state;
  }
};

export default CarAmigoImportReducer;
